import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';
import { UnstyledButton } from '../Button';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

export const VideoWrapper = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 100%;

  ${mediaQueries[0]} {
    width: 100vw;
    height: 100vw;
  }

  ${mediaQueries.min} {
    width: 100vw;
    height: 100vw;
  }

  ${mediaQueries.tablet} {
    width: 100%;
    height: 100%;
  }
`;

export const PlayIcon = styled('svg')`
  cursor: pointer;
  max-width: 100%;
  z-index: 0;
  margin: auto;
`;

export const VideoButton = styled(UnstyledButton)`
  z-index: 1;
  outline: 0;
  position: absolute;
  width: ${pxToRem(58)};
  height: ${pxToRem(58)};
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;

  .playIconBackground,
  .playIconCenter {
    transition: 0.2s fill ease;
  }

  &:hover .playIconBackground,
  &:focus .playIconBackground {
    fill: ${({ theme }) => theme.color.playIconCenter};
  }

  &:hover .playIconCenter,
  &:focus .playIconCenter {
    fill: ${({ theme }) => theme.color.playIconBackground};
  }

  ${mediaQueries.tablet} {
    width: ${pxToRem(80)};
    height: ${pxToRem(80)};
  }
`;
